module.exports = __webpack_public_path__ + "images/icon-96.f3961fb75e0169cc2c53ec4e414fbf45.png";